/**
 * The customer code for a "walkin" customer.
 *
 * @property WALKIN_CUSTOMER_CODE
 * @type {String}
 */
export const WALKIN_CUSTOMER_CODE = 'WALKIN'

/**
 * The length of the short code used for generating loyalty claim urls for a sale.
 *
 * @property SHORT_CODE_LENGTH
 * @type {Number}
 */
export const SHORT_CODE_LENGTH = 6

/**
 * Characters used to generate the short code for loyalty claim urls for a sale.
 *
 * @property SHORT_CODE_CHARS
 * @type {String}
 */
export const SHORT_CODE_CHARS =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'

/**
 * The latest version of the Sale model. This is used to identify the state of the sale model and help migrate
 * old versions to the latest.
 *
 * @property SALE_VERSION
 * @type {Number}
 */
export const SALE_VERSION = 13

/**
 * The promo code added event name
 *
 * @property PROMO_CODE_ADDED
 * @type {String}
 * @deprecated Only used in angularJS footer, remove when footer migrated to react
 */
export const PROMO_CODE_ADDED = 'promo-code-added'

/**
 * The Heap Action name for when the line item fulfilment decision modal is viewed.
 */
export const HEAP_LINE_ITEM_FULFILMENT_DECISION_ACTION = 'View'

/**
 * The Heap Object name for the packaging breakdown option.
 */
export const HEAP_PACKAGING_BREAKDOWN_OPTION_OBJECT =
  'Packaging Breakdown Option'
